import React, {Fragment, useCallback, useState} from 'react';
import {Field, Form, Formik} from 'formik';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {FormControl, IconButton, InputLabel, Select, Stack} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import {toast} from "@lb/mlib-components";
import AlertDialog from "../../layout/AlertDialog";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

const initialValues = {
    endDate: moment().format('YYYY-MM-DD'),
    startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 550,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
};
const excelDateToEpoch = (excelDate) => {
    return new Date(excelDate).getTime() / 1000;
};


export default function SamplesReport(props) {

    const [dealer, setDealer] = useState('all');
    const [noOrders, setNoOrders] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        props.handleClose();
    };
    const handleOpen = () => setOpen(true);

    function handleChangeDealer(event) {
        setDealer(event.target.value)
        setNoOrders(false)
    }

    const handleDownload = useCallback(async (values) => {
        const {startDate, endDate} = values;
        const startDateStr = startDate ? excelDateToEpoch(startDate) : '';
        const endDateStr = endDate ? excelDateToEpoch(endDate) : '';

        let data = {
            start: startDateStr,
            end: endDateStr
        }
        let url = `samples/excel`;
        if (dealer !== 'all')
            data = {...data, isdealer: dealer === 'isdealer'}

        axios.post(url, data, {
            responseType: 'blob', headers: {'Error-Message': ''}
        }).then((response) => {

            const filename = `samples_${startDate}_${endDate}.xlsx`;
            const urlObject = window.URL || window.webkitURL;
            const downloadUrl = urlObject.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                urlObject.revokeObjectURL(downloadUrl);
            }, 100);

        }).catch((error) => {
            if (error.response?.status === 404) {
                setNoOrders(true)
            } else toast.error('There was an error processing your request.', {
                action: key => (<AlertDialog message={error.response?.data?.detail || error.toString()}
                                             key={key}/>),
            });

        });

    }, [dealer])


    return <Fragment>
        <Button color="primary" variant={'outlined'} startIcon={<TableChartOutlinedIcon/>} onClick={handleOpen}>
            Report
        </Button>

        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        ><Formik initialValues={initialValues} onSubmit={handleDownload}>
            {(form) => (
                <Form>
                    <Box sx={style}>
                        <Box display="flex" alignItems="center">
                                <Box flexGrow={1}>
                                    <Typography variant="h5" component="div">
                                        Download Report
                                    </Typography>
                                </Box>
                                <Box>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon/>
                                    </IconButton>
                                </Box>
                            </Box>
                            <hr style={{
                                border: "0",
                                height: "0",
                                borderTop: "1px solid rgba(0, 0, 0, 0.5)",
                                borderBottom: "1px solid rgba(255, 255, 255, 0.3)"
                            }}/>


                                <Box margin={2}></Box>

                        <Stack direction={'row'} spacing={2}>
                            <Field name="startDate">
                                {({field}) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Start Date"
                                        InputLabelProps={{shrink: true}}
                                        onChange={(event) => {
                                            form.setFieldValue('startDate', event.target.value)
                                            setNoOrders(false)
                                        }}

                                    />
                                )}
                            </Field>
                            <Field name="endDate">
                                {({field}) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="End Date"
                                        InputLabelProps={{shrink: true}}
                                        onChange={(event) => {
                                            form.setFieldValue('endDate', event.target.value)
                                            setNoOrders(false)
                                        }}

                                    />
                                )}
                            </Field>
                            <FormControl sx={{width: '200px'}} marginBottom="normal" variant={"filled"}>
                                <InputLabel id="demo-simple-select-label">Filter by store</InputLabel>
                                <Select
                                    id="outlined-select-warehouse"
                                    label="Filter by store"
                                    value={dealer}
                                    onChange={handleChangeDealer}
                                    fullWidth
                                >
                                    <MenuItem value={'all'}>
                                        All
                                    </MenuItem>
                                    <MenuItem value={'isdealer'}>
                                        Dealers
                                    </MenuItem>
                                    <MenuItem value={'public'}>
                                        Public
                                    </MenuItem>
                                </Select>
                            </FormControl>

                        </Stack>
                        <Box margin={2}></Box>
                        {noOrders && 'No orders to show.'}
                                <Stack spacing={2} direction="row-reverse">

                                 <Button type="submit"
                                    disabled={form.values.startDate.length === 0 || form.values.endDate.length === 0}
                                    variant="contained" color="primary"
                                    startIcon={<DownloadIcon/>}
                            >
                                Download
                            </Button>

                            </Stack>
                    </Box>
                </Form>)}
        </Formik>
        </Modal>
    </Fragment>
};
